enum AppTheme {
    LIGHT_MODE = 0,
    DARK_MODE = 1,
}

export default AppTheme;